import { defineMessages } from "react-intl";

const DATA_REPORTING = "data-reporting";

const dataReportingMessages = defineMessages({
  dataReporting: {
    id: `${DATA_REPORTING}.data-reporting`,
    defaultMessage: "Data reporting",
    description:
      "Heading for the data reporting sub-section on data-retention page."
  },
  generateYourReport: {
    id: `${DATA_REPORTING}.generate-your-report`,
    defaultMessage:
      "Generate a report of your personal data collected in association with this MyEBSCO account.",
    description: "Bullet point text to describe user can generate a report"
  },
  generateYourReportWithFlag: {
    id: `${DATA_REPORTING}.generate-your-report-with-flag`,
    defaultMessage:
      "Generate a report of any personal data collected in association with this MyEBSCO account.",
    description: "Bullet point text to describe user can generate a report"
  },
  timeToCompleteReportRequest: {
    id: `${DATA_REPORTING}.time-to-complete-report-request`,
    defaultMessage:
      "Report requests will be completed within 15-60 minutes. Please return to the screen at that time.",
    description:
      "Bullet point text to describe user report request may take a while."
  },
  timeToCompleteReportRequestWithFlag: {
    id: `${DATA_REPORTING}.time-to-complete-report-request-with-flag`,
    defaultMessage:
      "Report requests may take some time to complete. You may return to this screen in 20-30 minutes to view your report.",
    description:
      "Bullet point text to describe user report request may take a while with flag."
  }
});

export default dataReportingMessages;
